export type InboxDirection = "inbound" | "outbound" | "all";

export function parseInboxDirection(value: unknown): InboxDirection {
  if (value === "outbound" || value === "all" || value === "inbound") {
    return value;
  }

  return "inbound";
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * The inbox picker's selection lives in the `aliasId` search param: nothing for
 * "all inboxes", one id, or several joined with commas. Old single-id links
 * therefore keep working. Anything that is not a UUID is dropped.
 */
export function parseInboxSelection(aliasId: string | undefined): string[] {
  if (!aliasId) return [];
  return [...new Set(aliasId.split(",").map((id) => id.trim()))].filter((id) => UUID.test(id));
}

export function serializeInboxSelection(aliasIds: string[]): string | undefined {
  return aliasIds.length > 0 ? aliasIds.join(",") : undefined;
}

/**
 * The thread filter for a selection. One inbox is the backend's own `alias_id`
 * filter; two or more are merged client-side (see merged-threads.ts), sorted so
 * the same set always maps to the same query cache entry.
 */
export function inboxSelectionFilter(aliasId: string | undefined): {
  aliasId?: string;
  aliasIds?: string[];
} {
  const selection = parseInboxSelection(aliasId);
  if (selection.length <= 1) return { aliasId: selection[0] };
  return { aliasIds: [...selection].sort() };
}
